import { ErrorBoundary } from 'react-error-boundary';
import { useParams } from 'react-router-dom';

import Dashboard2DetailTemplate from '@/features/Dashboard/components/Dashboard2DetailTemplate';
import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';

import ErrorDisplay from './components/ErrorDisplay';

const Dashboard2DetailPage = () => {
  const params = useParams();
  const wr = useWorkspaceRouter();
  if (!params.dashboard_alias) throw new Error('Dashboard alias is required');

  return (
    <ErrorBoundary
      fallback={<ErrorDisplay height="100%" />}
      onReset={() => {
        wr.push('/dashboard2/list');
      }}
    >
      <Dashboard2DetailTemplate
        key={params.dashboard_alias}
        alias={params.dashboard_alias}
      />
    </ErrorBoundary>
  );
};

export default Dashboard2DetailPage;
